import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider as PAGE_CONTEXT } from '../../contexts/PageContext';
import PAGE_COMPONENT from './Search';

// eslint-disable-next-line no-undef
const props = globalPageProps || {}; // eslint-disable-line no-undef

ReactDOM.hydrateRoot(
    document.getElementById('root'),
    <PAGE_CONTEXT PAGE_PROPS={props.PAGE_PROPS}>
        <PAGE_COMPONENT {...props} />
    </PAGE_CONTEXT>
);
